/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
import React from 'react';

import { IconName } from 'components/atoms/Icon';
import IssueCard from 'components/molecules/IssueCard';
import Section from 'components/organisms/Section';

interface IPhilosophy {
  icon: IconName;
  title: string;
  description: string;
}
/* Fake Data */
const data: IPhilosophy[] = [
  {
    icon: 'philosophy_1',
    title: 'Build fast → Learn faster',
    description:
      'Speed gives us more chances to learn. We test with real users, not just internal assumptions.',
  },
  {
    icon: 'philosophy_2',
    title: 'Kill quickly → Focus on what works',
    description:
      'We say no more than we say yes. If an idea doesn’t show traction, we move on — without ego.',
  },
  {
    icon: 'philosophy_3',
    title: 'AI with a purpose',
    description:
      'AI is not a buzzword here. It’s a tool. Every product we build uses AI in a way that solves a real problem better than anything before.',
  },
];
const OurPhilosophy:React.FC = () => (
  <Section>
    <Section.Title>Our Philosophy</Section.Title>
    <div className="p-about_philosophy_list">
      {data.map((item, index) => (
        <IssueCard key={index} icon={item.icon} title={item.title} description={item.description} />
        ))}
    </div>
  </Section>
  );

export default OurPhilosophy;
